import React from 'react'
import { Button } from 'react-bootstrap'
import './Inputs.css'

type TButtonColor = 'red' | 'blue' | 'outlined'

const cssClassByColor = (color?: TButtonColor) => {
  if (color === 'outlined') return 'btn-outlined '
  else if (color === 'red') return 'btn-red '
  else return 'btn-blue '
}

interface IButtonProp {
  href?: string
  color?: TButtonColor
  disabled?: boolean
  onClick?: (event: React.MouseEvent<HTMLElement>) => void
  style?: React.CSSProperties
  className?: string
  children?: any
}

const RoundButton: React.FC<IButtonProp> = ({
  href,
  color,
  disabled,
  onClick,
  style,
  className,
  children,
}: IButtonProp) => {
  return (
    <Button
      type='button'
      href={href}
      disabled={disabled}
      onClick={onClick}
      className={'btn btn-round ' + cssClassByColor(color) + className}
      style={style}
    >
      {children}
    </Button>
  )
}
export default RoundButton
